import { DateTime, Settings } from "luxon";

Settings.defaultLocale = "pt-BR";

export const date = {
  parse(input: string, format = "y-MM-dd HH:mm:ss"): DateTime {
    return DateTime.fromFormat(input, format);
  },
  format(input: string, outputFormat: string, inputFormat = "y-MM-dd HH:mm:ss"): string {
    const parsed = DateTime.fromFormat(input, inputFormat);
    return parsed.toFormat(outputFormat);
  },
  fromIso(input: string): DateTime {
    return DateTime.fromISO(input);
  },
  now(): DateTime {
    return DateTime.now();
  },
};
